import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import Tab from "./tab";
import "./tabNavigations.scss";

function TabNavigations(props: any) {
    const tabsState = useSelector((state: RootState) => state.tabRow.tabs);

    return (
        <>
            <Row className="tabRow">
                {tabsState.map((item, i) => (
                    <Tab
                        FullWidth={props.FullWidth}
                        label={item.label}
                        enquiryId={item.enquiryId}
                        active={item.active}
                        key={item.key}
                        onClick={item.onclick}
                    ></Tab>
                ))}
            </Row>
        </>
    );
}
export default TabNavigations;
